module.exports = __webpack_public_path__ + "static/media/hover_down_icon.1a0dbe61.svg";